import * as TP from '../types';

import { gql } from '@apollo/client';
import { KeyValueInfoFragmentDoc } from './keyValueInfo';
export type FacilityContactInfoFragment = (
  { readonly __typename?: 'FacilityContact' }
  & Pick<TP.FacilityContact, 'id' | 'name' | 'contactTypeId' | 'main' | 'phoneNumber' | 'extension' | 'faxNumber' | 'emailAddress' | 'chatUsername' | 'chatTypeId' | 'riskInfoSource' | 'thirdPartyId'>
  & { readonly chatType?: TP.Maybe<(
    { readonly __typename?: 'KeyValue' }
    & Pick<TP.KeyValue, 'active' | 'id' | 'metadataJson' | 'name'>
  )> }
);

export const FacilityContactInfoFragmentDoc = gql`
    fragment FacilityContactInfo on FacilityContact {
  id
  name
  contactTypeId
  main
  phoneNumber
  extension
  faxNumber
  emailAddress
  chatType {
    ...KeyValueInfo
  }
  chatUsername
  chatTypeId
  main
  riskInfoSource
  thirdPartyId
}
    ${KeyValueInfoFragmentDoc}`;